import React from 'react'
import { Box, Container, Typography } from '@mui/material'

//styles
import Header from './Header'
//types
import { AuthLayoutProps } from 'types'

const AuthLayout = ({ children, title, content }: AuthLayoutProps) => {
  return (
    <Container maxWidth="sm" sx={styles.container}>
      <Box sx={styles.box}>
        <div>
          <Header />
          {title && <Typography variant="h1">{title}</Typography>}
          {content}
        </div>
        {children}
      </Box>
    </Container>
  )
}

const styles = {
  container: {
    textAlign: 'center',
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '100svh',
    height: '100%',
  },
}

export default AuthLayout
